function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Provider } from '../context';
import { TooltipPosition } from '../Tooltip/types';
import Tooltip from '../Tooltip';

const TooltipProvider = ({
  children,
  className
}) => {
  const [title, setTitle] = React.useState('');
  const [isDisplay, setIsDisplay] = React.useState(false);
  const [color, setColor] = React.useState();
  const [position, setPosition] = React.useState({
    top: 0,
    left: 0,
    width: 0,
    height: 0
  });
  const [tipDirection, setTipDirection] = React.useState(TooltipPosition.BOTTOM);

  const display = (title, position, direction, color) => {
    setPosition(position);
    setTitle(title);
    setIsDisplay(true);
    setTipDirection(direction);
    color && setColor(color);
  };

  const hide = () => {
    setIsDisplay(false);
  };

  const rect = React.useMemo(() => {
    switch (tipDirection) {
      case TooltipPosition.TOP:
        return {
          width: position.width,
          height: 0,
          top: position.top,
          left: position.left
        };

      case TooltipPosition.BOTTOM:
        return {
          width: position.width,
          height: 0,
          top: position.top + position.height,
          left: position.left
        };

      case TooltipPosition.LEFT:
        return {
          width: 0,
          height: position.height,
          top: position.top,
          left: position.left
        };

      case TooltipPosition.RIGHT:
        return {
          width: 0,
          height: position.height,
          top: position.top,
          left: position.left + position.width
        };

      default:
        return {
          width: position.width,
          height: 0,
          top: position.top,
          left: position.left
        };
    }
  }, [position.height, position.left, position.top, position.width, tipDirection]);
  const value = React.useMemo(() => ({
    show: props => {
      const {
        title,
        position,
        direction,
        color
      } = props;
      display(title, position, direction, color);
    },
    hide: () => {
      hide();
    }
  }), []);
  return /*#__PURE__*/React.createElement(Provider, {
    value: value
  }, children, isDisplay && /*#__PURE__*/React.createElement(Tooltip, _extends({}, rect, {
    className: className,
    content: title,
    color: color,
    position: tipDirection
  })));
};

export default TooltipProvider;